import { graphql } from 'gatsby'

import React from 'react'
import Asterix from '../../icons/asterix'


function Link({ shopLinksEnabled,event,show }) {
    if (shopLinksEnabled && show ) {
        return (
            <a className='shop link uppercase inline-block' href={event.link} target="_blank" rel="noreferrer" referrerPolicy="no-referrer">
                {event.linkText || 'Shop'}
            </a>
        )
    }
    return null
}
export default function EventCard({ event, shopLinksEnabled,online = true, ...props }) {

    console.log(event.availableOnline)
    return (
        <div {...props} className=" event-card mb-[20px]  md:mb-[15px]  ">
            <div className="z-10 relative p-[20px]">
                <div className="flex justify-between mb-[20px]">
                    <h3 className='mr-[5px]'>{event.name}</h3>
                    {event.availableOnline && online ? <Asterix className='md:w-[15px]' /> : null}
                </div>
                <h5  dangerouslySetInnerHTML={{__html:event.description}} className="max-w-230 mb-[40px] events-para"></h5>
              
                <Link show={event.showShopLink} event={event} shopLinksEnabled={shopLinksEnabled} />

            </div>
            <img alt=''  className='bg-image' src={event.backgroundImage.url} />
        </div>
    )
}


export const query = graphql`
    fragment eventCard  on DatoCmsEvent{
        name
      description
      availableOnline
      backgroundImage {
        gatsbyImageData
      }
      model {
        apiKey
      }
      availableOnline
    }
`